import store from "../../../store/index";

const toTooltipDate = (dateString) => {
  const months = {
    1: "January",
    2: "Feburary",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };
  const dateStringArr = dateString.split("/");
  const year = dateStringArr[2];
  let dateText = "";
  if (dateString.split(" ").length > 1) {
    const dateHourArray = dateStringArr[1].split(" ");
    const day = dateHourArray[0];
    const time = dateHourArray[2];

    dateText = months[parseInt(dateStringArr[0])] + ` ${day}, ${year}`;
    dateText = `${dateText} , ${time}`;
  } else {
    dateText = months[parseInt(dateStringArr[0])] + ` ${dateStringArr[1]}, ${year}`;
  }

  const span = document.createElement("span");
  span.color = "#424B50";
  span.innerText = dateText;
  span.style.fontWeight = "700";
  span.style.fontSize = "16px";
  span.style.fontFamily = "'Roboto Slab', serif";
  return span;
};

const getOpensFromClicks = (chart, tooltip, index) => {
  const datapointIndex = tooltip.dataPoints[index].dataIndex;
  const datasetIndex = tooltip.dataPoints[index].datasetIndex;
  const opens = chart._metasets[datasetIndex + 1]?._parsed[datapointIndex]["y"];
  return "Unique Opens: " + (opens ?? 0);
};
const getClicksFromOpens = (chart, tooltip, index) => {
  const datapointIndex = tooltip.dataPoints[index].dataIndex;
  const datasetIndex = tooltip.dataPoints[index].datasetIndex;
  const clicks = chart._metasets[datasetIndex - 1]?._parsed[datapointIndex]["y"];
  return "Unique Clicks: " + (clicks ?? 0);
};

const getDeliveredFromStore = (chart, tooltip, index) => {
  const state = store.getState();
  const delieveredEmailsMap = state.analyticsGraph.deliveredEmailsSorted;
  const dateIndex = tooltip.dataPoints[index].dataIndex;
  const curveIndex = Math.floor(tooltip.dataPoints[index].datasetIndex / 2);
  const deliveredCount = delieveredEmailsMap[curveIndex]["delivered"][dateIndex];

  return `Delivered: ${deliveredCount}`;
};

const createTriangle = (colors) => {
  const triangle = document.createElement("div");
  triangle.style.height = "0px";
  triangle.style.width = "0px";
  triangle.style.display = "inline-block";
  triangle.style.borderLeftColor = "transparent";
  triangle.style.borderLeftWidth = "6px";
  triangle.style.borderLeftStyle = "solid";
  triangle.style.borderRightColor = "transparent";
  triangle.style.borderRightWidth = "6px";
  triangle.style.borderRightStyle = "solid";
  triangle.style.borderBottomColor = colors.backgroundColor;
  triangle.style.borderBottomWidth = "12px";
  triangle.style.borderBottomStyle = "solid";
  triangle.style.borderTopColor = "transparent";
  triangle.style.borderTopWidth = "0px";
  triangle.style.borderTopStyle = "solid";
  triangle.style.marginRight = "10px";
  return triangle;
};

const createDiamond = (colors) => {
  const diamond = document.createElement("div");
  diamond.style.height = "8px";
  diamond.style.transform = "rotate(45deg)";
  diamond.style.width = "8px";
  diamond.style.display = "inline-block";
  diamond.style.borderColor = colors.backgroundColor;
  diamond.style.background = "white";
  diamond.style.borderWidth = "1px";
  diamond.style.borderStyle = "solid";
  diamond.style.marginRight = "10px";
  diamond.style.marginLeft = "2px";
  return diamond;
};

const createCircle = (colors) => {
  const circle = document.createElement("div");
  circle.style.display = "inline-block";
  circle.style.height = "8px";
  circle.style.width = "8px";
  circle.style.borderRadius = "50%";
  circle.style.background = colors.backgroundColor;
  circle.style.fill = "black";
  circle.style.marginRight = "10px";
  circle.style.marginLeft = "2px";
  return circle;
};
const createSpan = (colors, body, type) => {
  const triangle = createTriangle(colors);
  const diamond = createDiamond(colors);
  const circle = createCircle(colors);

  const tr = document.createElement("tr");
  tr.style.backgroundColor = "inherit";
  tr.style.borderWidth = 0;

  const td = document.createElement("td");
  td.style.borderWidth = 0;

  const text = document.createTextNode(body);

  if (type === "click") {
    td.appendChild(diamond);
  } else if (type === "delivered") {
    td.appendChild(circle);
  } else {
    td.appendChild(triangle);
  }

  td.appendChild(text);
  tr.appendChild(td);
  return tr;
};
const getOrCreateTooltip = (chart) => {
  let tooltipEl = document.getElementById("chartjs-tooltip");

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.setAttribute("id", "chartjs-tooltip");
    tooltipEl.style.backgroundColor = "white";
    tooltipEl.style.borderRadius = "15px";
    tooltipEl.style.color = "#7E7E7E";
    tooltipEl.style.opacity = 1;
    tooltipEl.style.pointerEvents = "none";
    tooltipEl.style.position = "absolute";
    tooltipEl.style.transform = "translate(-50%, 0)";
    tooltipEl.style.transition = "all .1s ease";
    tooltipEl.style.width = "205px";
    tooltipEl.style.minHeight = "150px";
    tooltipEl.style.boxShadow = "0px 2px 60px #B7B7B7";
    tooltipEl.style.zIndex = "+1";

    const containerDiv = document.createElement("div");
    containerDiv.id = "tooltip-inner";
    containerDiv.style.width = "100%";
    containerDiv.style.borderRadius = "15px";

    tooltipEl.appendChild(containerDiv);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

const determineSkipIndices = (bodyLines, tooltip) => {
  const skipIndices = [];
  const dataSetIndicesList = [];
  for (let i = 0; i < bodyLines.length; ++i) {
    const dataSetIndex = tooltip.dataPoints[i].datasetIndex;
    const counterDataSet = dataSetIndex % 2 === 0 ? dataSetIndex + 1 : dataSetIndex - 1;
    if (!dataSetIndicesList.includes(counterDataSet)) {
      dataSetIndicesList.push(dataSetIndex);
    } else {
      skipIndices.push(dataSetIndex);
    }
  }
  return skipIndices;
};

export const externalTooltipHandler = (context) => {
  // Tooltip Element
  const { chart, tooltip } = context;
  const tooltipEl = getOrCreateTooltip(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set Text

  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map((b) => b.lines);

    const dateSection = document.createElement("div");
    dateSection.style.background = "white";
    dateSection.style.padding = "25px";
    dateSection.width = "100%";
    dateSection.style.borderTopLeftRadius = "15px";
    dateSection.style.borderTopRightRadius = "15px";

    dateSection.appendChild(toTooltipDate(titleLines[0]));

    const statsSection = document.createElement("div");
    statsSection.style.background = "#F8F8F8";
    statsSection.style.padding = "25px";
    statsSection.width = "100%";
    statsSection.style.borderBottomLeftRadius = "15px";
    statsSection.style.borderBottomRightRadius = "15px";

    const skipIndices = determineSkipIndices(bodyLines, tooltip);

    bodyLines.forEach((body, i) => {
      if (skipIndices?.includes(tooltip.dataPoints[i].datasetIndex)) {
        return;
      }
      const colors = { ...tooltip.labelColors[i], backgroundColor: tooltip.labelColors[i].borderColor };
      const pointText = tooltip.dataPoints[i].datasetIndex % 2 === 0 ? "Clicks" : "Opens";
      const indexOfLastColon = body[0].lastIndexOf(":");
      const pointValue = body[0].substring(indexOfLastColon + 1, body[0].length).trim();
      const openClickStats = pointText.includes("Opens")
        ? getClicksFromOpens(chart, tooltip, i)
        : getOpensFromClicks(chart, tooltip, i);
      const tooltipValues = {
        Delivered: getDeliveredFromStore(chart, tooltip, i),
        Opens: "",
        Clicks: "",
      };
      if (pointText.includes("Opens")) {
        tooltipValues["Opens"] = "Unique Opens: " + (pointValue ?? 0);
        tooltipValues["Clicks"] = openClickStats ?? 0;
      } else {
        tooltipValues["Opens"] = openClickStats ?? 0;
        tooltipValues["Clicks"] = "Unique Clicks: " + (pointValue ?? 0);
      }
      statsSection.appendChild(createSpan(colors, [tooltipValues["Delivered"]], "delivered"));
      statsSection.appendChild(createSpan(colors, [tooltipValues["Opens"]], "open"));
      statsSection.appendChild(createSpan(colors, [tooltipValues["Clicks"]], "click"));
    });

    const tableRoot = document.querySelector("#tooltip-inner");
    // Remove old children
    while (tableRoot?.firstChild) {
      tableRoot.innerHTML = "";
    }
    tableRoot?.appendChild(dateSection);
    tableRoot?.appendChild(statsSection);
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;
  tooltipEl.style.left = positionX + tooltip.caretX + "px";
  tooltipEl.style.top = positionY + tooltip.caretY + "px";
  tooltipEl.style.font = tooltip.options.bodyFont.string;
};
